// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__20bFH","balanceDisclaimer":"posDashboard_balanceDisclaimer__3IAcG"};